import React, { useCallback, useRef } from "react";

/**
 * Botão magnético: acompanha levemente o cursor e volta com mola.
 * Renderiza <a> quando recebe `href`, senão <button>.
 */
const MagneticButton = ({
  href,
  strength = 0.32,
  className = "",
  children,
  ...rest
}) => {
  const ref = useRef(null);
  const inner = useRef(null);

  const onMouseMove = useCallback(
    (event) => {
      const el = ref.current;
      if (!el) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const rect = el.getBoundingClientRect();
      const x = (event.clientX - rect.left - rect.width / 2) * strength;
      const y = (event.clientY - rect.top - rect.height / 2) * strength;
      el.style.transition = "transform .15s linear";
      el.style.transform = `translate(${x}px, ${y}px)`;
      if (inner.current) {
        inner.current.style.transform = `translate(${x * 0.28}px, ${y * 0.28}px)`;
      }
    },
    [strength]
  );

  const onMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transition = "transform .6s cubic-bezier(.34,1.56,.64,1)";
    el.style.transform = "translate(0,0)";
    if (inner.current) {
      inner.current.style.transition = "transform .6s cubic-bezier(.34,1.56,.64,1)";
      inner.current.style.transform = "translate(0,0)";
    }
  }, []);

  const Tag = href ? "a" : "button";

  return (
    <Tag
      ref={ref}
      href={href}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      className={`btn-shine inline-flex items-center justify-center gap-2 ${className}`}
      {...rest}
    >
      <span ref={inner} className="inline-flex items-center gap-2">
        {children}
      </span>
    </Tag>
  );
};

export default MagneticButton;
